module.exports = __webpack_public_path__ + "img/42f06c143ebe4db69113b17649897760-1024.c365bfb1.jpg";